export const dictionary = {
  header: {
    switchToDarkMode: 'Dark mode',
    switchToLightMode: 'Light mode',
  },

  auth: {
    login: {
      title: 'Login',
      subTitle: 'Continue to 4IE Projects',

      buttonLogin: 'Login',
      buttonLoginWithGoogle: 'Login with Google',
      buttonLoginWithMicrosoft: 'Login with Microsoft',
      buttonCreateAccount: 'Create account',
      buttonForgotPassword: 'Forgot password',
      dontHaveAccount: 'Don\'t have an account?',
    },

    signUp: {
      title: 'Sign up',

      buttonSignup: 'Sign up',
      buttonLogin: 'Login',
      alreadyHaveAccount: 'Already have an account?',
    },

    resetPassword: {
      title: 'Reset password',

      buttonLogin: 'Login',
      buttonReset: 'Reset password',

      passwordResetEmailSent: 'Password Reset Email Sent',
    },

    validations: {
      userWithThisEmailAlreadyExists: 'User with this email already exists',
      userNotFound: 'User not found',
      passwordsDoNotMatch: 'Passwords do not match',
      emailOrPasswordWrong: 'Email or password wrong',
      thePasswordMustBeAtLeast8CharactersLong: 'The password must be at least 8 characters long',
    },

    impersonate: {
      noToken: 'Token is not present',
      invalidToken: 'Token is invalid or expired',
    },

    firebase: {
      errors: {
        'auth/account-exists-with-different-credential': 'This account already exists with a different login provider',
      },
    },
    divider: 'or',
  },

  users: {
    labelTypeAdmin: 'Admin',
    labelTypeHomeowner: 'Homeowner',
    labelTypePartner: 'Partner',

    invite: {
      dialog: {
        title: 'Invite team members',
        placeholderEmail: 'Email, comma separated',
        buttonInvite: 'Send invite',
        invitationSentInfo: (email: string) => `Invitation to ${email} sent`,
      },

      title: 'Team invitation',
      subtitle: (company?: string) => company ? `You've been invited to join ${company}'s team` : 'You\'ve been invited to join a team',
      buttonAcceptInvitation: 'Create account',
      inviteButton: 'Invite Team Member',
    },

    team: {
      title: 'Team',

      detailsLabel: 'Details',

      buttonInvite: 'Invite user',
    },

    create: {
      title: 'Create user',
      buttonCreate: 'Create user',
    },

    edit: {
      buttonEdit: 'Edit user',
      buttonDelete: 'Delete user',
      deleteConfirmation: 'Are you sure you want to delete this user?',
    },
  },

  projects: {
    board: {
      title: 'Project Board',
      subtitle: 'Track project progress across all stages',

      filterSearchPlaceholder: 'Search projects by name or id',
    },
  },

  leads: {
    form: {
      eyebrow: '4i Energy Hub',
      title: 'Welcome to the 4i Energy Hub',
      description: '4i Energy is here to help you understand your home’s potential to be more resilient, efficient and cost effective. We are focused on educating and innovating to drive more value to you, the property owner.',
      referredByPrefix: 'Referred by',
      referredByPlaceholder: 'Name of who referred you',
      confirmLabel: 'Confirm your details',
      fieldFirstName: 'First name',
      fieldLastName: 'Last name',
      placeholderFirstName: 'Jane',
      placeholderLastName: 'Smith',
      placeholderEmail: 'jane@example.com',
      placeholderPhone: '(555) 000-0000',
      fieldStreetAddress: 'Street Address',
      placeholderStreetAddress: '123 Main St, Reston, VA 20190',
      selectAddressError: 'Please select your address from the list',
      marketingConsentLabel: 'I agree to receive marketing communications and promotional offers from 4i Energy, LLC at the contact information provided.',
      marketingConsentError: 'Please agree to continue.',
      fieldFullName: 'Full Name',
      fieldInterests: 'What are you interested in learning more about?',
      fieldInterestOther: 'Please describe your interest',
      fieldPartner: 'Confirm your home improvement company',
      fieldCompanyRepresentative: 'Company Representative',
      fieldUtilityBill: 'Utility Bill',
      buttonUploadBill: 'Upload Utility Bill',
      utilityBillHelperText: 'Accepted formats: PDF, PNG, JPG. Max 10MB.',
      consentLabel: 'I agree to receive emails and/or SMS updates from 4i related to energy products for my home. I understand I may opt out at any time.',
      consentRequired: 'You must agree to continue',
      buttonSubmit: 'Join the 4i Energy Hub',
      hubFeaturesLabel: 'In the hub you can',
      hubFeatures: [
        'Learn and Earn',
        'Build your home’s profile',
        'Find out more about incentives',
        'Talk with an expert',
        'And much more',
      ],
      partnersLabel: 'Featured Partners',
    },
    success: {
      title: 'Welcome to the hub!',
      body: 'Thanks for joining. A member of the 4i Energy team will be in touch shortly to help you get the most out of your home.',
      emailVerification: 'We sent you an email verifying your access to the 4i Energy Hub.',
      hubButton: 'Go to the 4i Energy Hub',
      hubUrl: 'https://sites.google.com/4i.energy/4i-energyhub/home',
      contactInfo: 'For additional questions, contact us directly at (703) 651-0008 or experts@4i.energy',
    },
    partnerNotFound: {
      title: 'Lead form unavailable',
      message: 'This lead form link is invalid or no longer active. Please contact your home improvement company for an updated link.',
    },
    list: {
      title: 'Leads',
      subtitle: 'Manage and follow up with incoming leads.',
      searchPlaceholder: 'Search by lead name or ID',
      buttonAddLead: 'Add Lead',
      empty: 'No leads found',
      columnId: 'ID',
      columnName: 'Name',
      columnEmail: 'Email',
      columnPhone: 'Phone',
      columnAddress: 'Address',
      columnInterest: 'Interest',
      columnPartner: 'Partner',
      columnRepresentative: 'Representative',
      columnDocuments: 'Documents',
      columnNote: 'Note',
      columnLostReason: 'Lost Reason',
      columnStatus: 'Status',
      columnAssignedTo: 'Assigned To',
      columnCreatedAt: 'Date Created',
      toggleStatusColors: 'Status colors',
      countLeads: (n: number) => `${n} ${n === 1 ? 'lead' : 'leads'}`,
    },
    statuses: {
      newLead: 'New Lead',
      outreachAttempted: 'Outreach Attempted',
      followUp: 'Follow Up',
      consultationScheduled: 'Consultation Scheduled',
      sentToAurora: 'Sent to Aurora',
      contractSent: 'Contract Sent',
      closedWon: 'Closed - Won',
      closedLost: 'Closed - Lost',
    },
    lostReasons: {
      noInterest: 'Lost: No interest/Dead',
      noContact: 'Lost: No contact - follow up',
      timing: 'Lost: Timing - follow up',
      ghosted: 'Lost: Ghosted - follow up',
      financing: 'Lost: Financing - follow up',
      wentWithCompetitor: 'Lost: Went with competitor',
      badContactInfo: 'Lost: Bad contact info',
    },
    lostReason: {
      title: 'Why was this lead lost?',
      description: 'Select a reason to close this lead as lost.',
      label: 'Lost reason',
      buttonConfirm: 'Close as lost',
      buttonCancel: 'Cancel',
      required: 'Please select a reason',
    },
    filters: {
      partner: 'Partner',
      status: 'Status',
      allStatuses: 'All statuses',
      assignees: 'Assigned User',
      created: 'Date Created',
      createdAfter: 'From',
      createdBefore: 'To',
      dateShortcuts: {
        today: 'Today',
        thisWeek: 'This week',
        lastWeek: 'Last week',
        last30Days: 'Last 30 days',
        thisMonth: 'This month',
        lastMonth: 'Last month',
        thisYear: 'This year',
        reset: 'Reset',
      },
    },
    note: {
      title: 'Lead note',
      placeholder: 'Add a comment about this lead',
      buttonSave: 'Save note',
      buttonCancel: 'Cancel',
      counter: (length: number, max: number) => `${length}/${max}`,
      maxLengthError: (max: number) => `Note must be at most ${max} characters`,
    },
    documents: {
      title: 'Lead documents',
      empty: 'No documents uploaded',
      buttonOpen: 'Open',
    },
    create: {
      title: 'Add Lead',
      subtitle: 'Create a new lead.',
      buttonCreate: 'Create lead',
      success: 'Lead created successfully',
    },
    actions: {
      menuLabel: 'Lead actions',
      addNote: 'Add note',
      editNote: 'Edit note',
      viewDocuments: 'View documents',
      sendToAurora: 'Send to Aurora',
      sendToAuroraSuccess: 'Lead sent to Aurora',
      createProject: 'Create Project',
      createProjectSuccess: 'Project created from lead',
      impersonate: 'View hub as homeowner',
      impersonateUnavailable: 'No homeowner account yet',
    },
    impersonate: {
      starting: 'Opening the hub as this homeowner…',
      failed: 'Could not open the hub as this homeowner',
    },
  },

  companies: {
    list: {
      title: 'Companies',

      nameLabel: 'Name',
    },

    create: {
      title: 'Create company',
      buttonCreate: 'Create company',
    },

    edit: {
      buttonEdit: 'Edit company',
      buttonDelete: 'Delete company',
      deleteConfirmation: 'Are you sure you want to delete this company?',
    },
  },

  menu: {
    auth: {
      login: 'Log In',
      logout: 'Log Out',
      signUp: 'Signup',
    },
    dashboard: 'Dashboard',
    users: {
      list: 'Users',
      team: 'Team',
      myAccount: 'My account',
      create: 'Create user',
    },
    companies: {
      list: 'Companies',
      create: 'Create company',
    },
    projects: {
      list: 'Projects',
    },
    leads: {
      list: 'Leads',
      create: 'Add Lead',
    },
  },

  forms: {
    fieldEmail: 'Email',
    fieldPhone: 'Phone',
    fieldPassword: 'Password',
    labelOptional: '(Optional)',
    buttonCreate: 'Create',
    buttonEdit: 'Save changes',
    buttonDelete: 'Delete',

    signup: {
      fieldRepeatPassword: 'Repeat Password',
    },
    user: {
      fieldName: 'Name',
      fieldLastName: 'Last name',
      fieldType: 'Type',
      fieldCompany: 'Company',
      fieldPosition: 'Position',
      fieldPicture: 'Upload picture',
      fieldSurname: 'Surname',
      fieldEmailDisabledHelper: 'Please contact support to change the email.',
    },
    company: {
      fieldName: 'Name',
      fieldPrimaryContact: 'Primary Contact',
    },

    validations: {
      required: 'This Field is Required',
      invalidDate: 'Date is Invalid',
      invalidEmail: 'Email is Invalid',
      invalidPhone: 'Phone number is Invalid',
      invalidYear: 'The year is incorrect',
      invalidPassword: 'Password is Invalid. At least 1 number is required.',
      invalidFileSize: (max: string) => `File is too big. Maximum is ${max}`,
      invalidFileType: 'File type is not valid',
      minLength: (length: number | string) => `Need to have at least ${length} characters`,
      maxLength: (length: number | string) => `Can't have more than ${length} characters`,
      oneOrMoreFieldsAreIncorrect: 'One or more fields are incorrect.',
      memberInvitationAllEmailsValid: 'One or more emails is invalid.',
    },
  },

  filters: {
    title: 'Filters',
    fieldSearch: 'Search',
  },

  feedback: {
    changesSaved: 'Changes saved successfully',
    linkCopied: 'Link copied to clipboard',
  },

  dialogs: {
    defaultTitle: 'Are you sure you want to do this?',
    defaultContent: 'This action is irreversible.',
    buttonNo: 'No',
    buttonYes: 'Yes',
    buttonCancel: 'Cancel',
    buttonClose: 'Close',
  },

  errors: {
    noPagePermission: 'You are not allowed to view this page',
    somethingWentWrong: 'Something went wrong!',
  },

  routes: {

  },

  countries: {
    US: 'United States',
    AF: 'Afghanistan',
    AX: 'Aland Islands',
    AL: 'Albania',
    DZ: 'Algeria',
    AS: 'American Samoa',
    AD: 'Andorra',
    AO: 'Angola',
    AI: 'Anguilla',
    AQ: 'Antarctica',
    AG: 'Antigua And Barbuda',
    AR: 'Argentina',
    AM: 'Armenia',
    AW: 'Aruba',
    AU: 'Australia',
    AT: 'Austria',
    AZ: 'Azerbaijan',
    BS: 'Bahamas',
    BH: 'Bahrain',
    BD: 'Bangladesh',
    BB: 'Barbados',
    BY: 'Belarus',
    BE: 'Belgium',
    BZ: 'Belize',
    BJ: 'Benin',
    BM: 'Bermuda',
    BT: 'Bhutan',
    BO: 'Bolivia',
    BQ: 'Bonaire, Sint Eustatius and Saba',
    BA: 'Bosnia And Herzegovina',
    BW: 'Botswana',
    BV: 'Bouvet Island',
    BR: 'Brazil',
    IO: 'British Indian Ocean Territory',
    BN: 'Brunei Darussalam',
    BG: 'Bulgaria',
    BF: 'Burkina Faso',
    BI: 'Burundi',
    KH: 'Cambodia',
    CM: 'Cameroon',
    CA: 'Canada',
    CV: 'Cape Verde',
    KY: 'Cayman Islands',
    CF: 'Central African Republic',
    TD: 'Chad',
    CL: 'Chile',
    CN: 'China',
    CX: 'Christmas Island',
    CC: 'Cocos (Keeling) Islands',
    CO: 'Colombia',
    KM: 'Comoros',
    CG: 'Congo',
    CD: 'Congo, Democratic Republic of the',
    CK: 'Cook Islands',
    CR: 'CostaRica',
    CI: 'Cote d\'Ivoire',
    HR: 'Croatia',
    CU: 'Cuba',
    CW: 'Curacao',
    CY: 'Cyprus',
    CZ: 'Czech Republic',
    DK: 'Denmark',
    DJ: 'Djibouti',
    DM: 'Dominica',
    DO: 'Dominican Republic',
    EC: 'Ecuador',
    EG: 'Egypt',
    SV: 'El Salvador',
    GQ: 'Equatorial Guinea',
    ER: 'Eritrea',
    EE: 'Estonia',
    ET: 'Ethiopia',
    FK: 'Falkland Islands',
    FO: 'Faroe Islands',
    FJ: 'Fiji',
    FI: 'Finland',
    FR: 'France',
    GF: 'French Guiana',
    PF: 'French Polynesia',
    TF: 'French Southern Territories',
    GA: 'Gabon',
    GM: 'Gambia',
    GE: 'Georgia',
    DE: 'Germany',
    GH: 'Ghana',
    GI: 'Gibraltar',
    GR: 'Greece',
    GL: 'Greenland',
    GD: 'Grenada',
    GP: 'Guadeloupe',
    GU: 'Guam',
    GT: 'Guatemala',
    GG: 'Guernsey',
    GN: 'Guinea',
    GW: 'GuineaBissau',
    GY: 'Guyana',
    HT: 'Haiti',
    HM: 'Heard Island and McDonald Islands',
    VA: 'Holy See (Vatican City State)',
    HN: 'Honduras',
    HK: 'Hong Kong',
    HU: 'Hungary',
    IS: 'Iceland',
    IN: 'India',
    ID: 'Indonesia',
    IR: 'Iran',
    IQ: 'Iraq',
    IE: 'Ireland',
    IM: 'IsleOfMan',
    IL: 'Israel',
    IT: 'Italy',
    JM: 'Jamaica',
    JP: 'Japan',
    JE: 'Jersey',
    JO: 'Jordan',
    KZ: 'Kazakhstan',
    KE: 'Kenya',
    KI: 'Kiribati',
    KR: 'Korea, Republic of',
    KP: 'Korea, Democratic People\'s Republic of',
    XK: 'Kosovo',
    KW: 'Kuwait',
    KG: 'Kyrgyzstan',
    LA: 'Lao People\'s Democratic Republic',
    LV: 'Latvia',
    LB: 'Lebanon',
    LS: 'Lesotho',
    LR: 'Liberia',
    LY: 'Libya',
    LI: 'Liechtenstein',
    LT: 'Lithuania',
    LU: 'Luxembourg',
    MO: 'Macao',
    MK: 'Macedonia',
    MG: 'Madagascar',
    MW: 'Malawi',
    MY: 'Malaysia',
    MV: 'Maldives',
    ML: 'Mali',
    MT: 'Malta',
    MH: 'Marshall Islands',
    MQ: 'Martinique',
    MR: 'Mauritania',
    MU: 'Mauritius',
    YT: 'Mayotte',
    MX: 'Mexico',
    FM: 'Micronesia',
    MD: 'Moldova',
    MC: 'Monaco',
    MN: 'Mongolia',
    ME: 'Montenegro',
    MS: 'Montserrat',
    MA: 'Morocco',
    MZ: 'Mozambique',
    MM: 'Myanmar',
    NA: 'Namibia',
    NR: 'Nauru',
    NP: 'Nepal',
    NL: 'Netherlands',
    NC: 'NewCaledonia',
    NZ: 'NewZealand',
    NI: 'Nicaragua',
    NE: 'Niger',
    NG: 'Nigeria',
    NU: 'Niue',
    NF: 'Norfolk Island',
    MP: 'Northern Mariana  Islands',
    NO: 'Norway',
    OM: 'Oman',
    PK: 'Pakistan',
    PW: 'Palau',
    PS: 'Palestine, State of',
    PA: 'Panama',
    PG: 'Papua New Guinea',
    PY: 'Paraguay',
    PE: 'Peru',
    PH: 'Philippines',
    PN: 'Pitcairn',
    PL: 'Poland',
    PT: 'Portugal',
    PR: 'Puerto Rico',
    QA: 'Qatar',
    RE: 'Reunion',
    RO: 'Romania',
    RU: 'Russian Federation',
    RW: 'Rwanda',
    BL: 'Saint Barthelemy',
    SH: 'Saint Helena',
    KN: 'Saint Kitts And Nevis',
    LC: 'Saint Lucia',
    MF: 'Saint Martin',
    PM: 'Saint Pierre And Miquelon',
    VC: 'Saint Vincent and the Grenadines',
    WS: 'Samoa',
    SM: 'San Marino',
    ST: 'Sao Tome and Principe',
    SA: 'SaudiArabia',
    SN: 'Senegal',
    RS: 'Serbia',
    SC: 'Seychelles',
    SL: 'Sierra Leone',
    SG: 'Singapore',
    SX: 'Sint Maarten',
    SK: 'Slovakia',
    SI: 'Slovenia',
    SB: 'Solomon Islands',
    SO: 'Somalia',
    ZA: 'SouthAfrica',
    GS: 'South Georgia and the South Sandwich Islands',
    SS: 'South Sudan',
    ES: 'Spain',
    LK: 'Sri Lanka',
    SD: 'Sudan',
    SR: 'Suriname',
    SJ: 'Svalbard and Jan Mayen',
    SZ: 'Swaziland',
    SE: 'Sweden',
    CH: 'Switzerland',
    SY: 'Syrian Arab Republic',
    TW: 'Taiwan',
    TJ: 'Tajikistan',
    TZ: 'Tanzania',
    TH: 'Thailand',
    TL: 'TimorLeste',
    TG: 'Togo',
    TK: 'Tokelau',
    TO: 'Tonga',
    TT: 'Trinidad and Tobago',
    TN: 'Tunisia',
    TR: 'Turkey',
    TM: 'Turkmenistan',
    TC: 'Turks and Caicos Islands',
    TV: 'Tuvalu',
    UG: 'Uganda',
    UA: 'Ukraine',
    AE: 'United Arab Emirates',
    GB: 'United Kingdom',
    UM: 'United States Minor Outlying Islands',
    UY: 'Uruguay',
    UZ: 'Uzbekistan',
    VU: 'Vanuatu',
    VE: 'Venezuela',
    VN: 'Vietnam',
    VG: 'British Virgin Islands',
    VI: 'US Virgin Islands',
    WF: 'Wallis and Futuna',
    EH: 'Western Sahara',
    YE: 'Yemen',
    ZM: 'Zambia',
    ZW: 'Zimbabwe',
  },
};

export default dictionary;
